import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
  },
  card: {
    padding: '10px 0',
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  heading: {
    padding: '0 15px 0 16px',
    fontWeight: 700,
    fontSize: 25,
    color: '#58595B',
    margin: '10px 0 10px 0',
  },
  wrapper: {
    margin: 20,
    overflowX: 'auto',
    '&>*': {
      overflowX: 'auto',
    },
  },
  card__wrapper: {
    padding: '0 10px',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  },
  colorPrimary: {
    backgroundColor: '#E5E5E5',
  },
  barColorPrimary: {
    backgroundColor: '#109CF1',
  },
}));

export default useStyles;

